import { render, staticRenderFns } from "./ListMonitoring.vue?vue&type=template&id=b2a411be&"
import script from "./ListMonitoring.vue?vue&type=script&lang=js&"
export * from "./ListMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports